import { render } from "./TeamTeammates.vue?vue&type=template&id=07190266"
import script from "./TeamTeammates.vue?vue&type=script&lang=js"
export * from "./TeamTeammates.vue?vue&type=script&lang=js"

import "./TeamTeammates.vue?vue&type=style&index=0&id=07190266&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__